// Create React App only exposes env vars prefixed with REACT_APP_
export const API_GATEWAY_BASE_URL: string | undefined = process.env.REACT_APP_API_GATEWAY_BASE_URL;
export const API_GATEWAY_KEY: string | undefined = process.env.REACT_APP_API_GATEWAY_KEY;

export function isGatewayConfigured(): boolean {
    return Boolean(API_GATEWAY_BASE_URL && API_GATEWAY_KEY);
}

export function getGatewayAuthHeader(): { Authorization: string } {
    if (!API_GATEWAY_KEY) {
        throw new Error("API_GATEWAY_KEY is not defined in environment.");
    }
    return {Authorization: `Bearer ${API_GATEWAY_KEY}`};
}

